import { ActionType, getType } from 'typesafe-actions';

import { workFlowActions } from './workFlow.actions';
import { WorkFlowState } from './workFlow.types';

const INITIAL_STATE: WorkFlowState = {
  activeStep: -1,
  showVerticalWorkFlow: true,
  showHorizontalWorkFlow: false,
  pogDashboardTableHeight: 0,
  toolTipDesc: {
    showDesc: true,
    activeDesc: 0,
    desc: '',
    toolTipHeight: 0
  },
  showDescStore: {
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
  }
};

export function workFlow(
  state: WorkFlowState = INITIAL_STATE,
  action: ActionType<typeof workFlowActions>
): WorkFlowState {
  switch (action.type) {
    case getType(workFlowActions.setActiveStep):
      return {
        ...state,
        activeStep: action.payload,
      };
    case getType(workFlowActions.setShowVerticalWorkFlow):
      return {
        ...state,
        showVerticalWorkFlow: action.payload,
      };
    case getType(workFlowActions.setShowHorizontalWorkFlow):
      return {
        ...state,
        showHorizontalWorkFlow: action.payload,
      };
    case getType(workFlowActions.setPogDashboardTableHeight):
      return {
        ...state,
        pogDashboardTableHeight: action.payload,
      };
    case getType(workFlowActions.setWorkFlowToolTipDesc):
      return {
        ...state,
        toolTipDesc: action.payload,
      };
    case getType(workFlowActions.setShowDescStore):
      return {
        ...state,
        showDescStore: {
          ...state.showDescStore,
          ...action.payload,
        },
      };
  }

  return state;
}
